@if (selectedIndicator) {
  <div class="p-card px-3 pt-1 pb-3">
    <div class="flex align-items-center gap-1">
      <app-header
        styleClass="text-primary"
        [text]="selectedIndicator.name"
        [icon]="getIconByIndicatorType(!!selectedIndicator.isSet)"></app-header>
      <p-menu #menu [model]="menuItems" [popup]="true" appendTo="body" />
      <p-button
        [rounded]="true"
        severity="secondary"
        tooltipPosition="left"
        pTooltip="zurück zu den Indikatoren"
        class="ml-auto"
        [text]="true"
        [routerLink]="[
          '/data-backend',
          { outlets: { overlay: 'indikatoren' } },
        ]"
        icon="fas fa-folder-tree" />
      @if (hasRightsToModify) {
        <p-button
          [rounded]="true"
          severity="secondary"
          [text]="true"
          (click)="menu.toggle($event)"
          icon="fas fa-ellipsis-vertical" />
      } @else {
        <a
          pButton
          class="p-button-xs"
          (click)="closeIndicator()"
          severity="secondary"
          [rounded]="true"
          icon="fas fa-xmark"></a>
      }
    </div>

    <div class="p-card p-3 surface-ground mb-3">
      <app-tag-list
        styleClass="text-xs mb-2"
        *ngIf="selectedIndicator.tags && selectedIndicator.tags.length"
        [tagIds]="selectedIndicator.tags"></app-tag-list>
      <div class="flex gap-2 align-items-center flex-wrap">
        <p-chip
          pTooltip="Status"
          [showDelay]="300"
          [icon]="selectedIndicator.locked ? 'fas fa-lock' : 'fas fa-check'"
          [label]="selectedIndicator.locked ? 'gesperrt' : 'freigegeben'"
          styleClass="text-xs cursor-help">
        </p-chip>
        <p-chip
          pTooltip="Schlüssel"
          [showDelay]="300"
          icon="fas fa-key"
          [label]="selectedIndicator.key"
          styleClass="text-xs cursor-help"></p-chip>
        <p-chip
          pTooltip="Einheit"
          [showDelay]="300"
          styleClass="text-xs cursor-help"
          [label]="
            units[selectedIndicator.unit]
              ? units[selectedIndicator.unit].name
              : ''
          "></p-chip>
        <p-chip
          pTooltip="Ordner"
          [showDelay]="300"
          *ngIf="!selectedIndicator.pool"
          icon="fas fa-folder"
          styleClass="p-chip-category text-xs cursor-help"
          [label]="
            categoryStore.getById(selectedIndicator.category)?.name ||
            'kein Ordner'
          "></p-chip>
        <p-chip
          styleClass="text-xs flex gap-2 align-items-center cursor-help"
          pTooltip="Dezimalstellen"
          [showDelay]="300">
          <code class="text-icon">x,xx</code>
          {{
            globalStore.getDecimals(selectedIndicator.unit, selectedIndicator)
          }}
        </p-chip>
      </div>
    </div>
    <p-accordion [activeIndex]="1">
      <p-accordionTab header="Metainformationen">
        <div class="grid">
          <div class="col-6">
            <app-header
              icon="fas fa-earth-europe"
              text="Öffentliche Informationen"></app-header>
          </div>
          <div class="col-6">
            <app-header
              icon="fas fa-house-user"
              text="Geschützte Informationen"></app-header>
          </div>
          @for (
            property of [
              { propertyName: 'calculation', label: 'Berechnung' },
              { propertyName: 'hint', label: 'Interner Hinweis' },
              { propertyName: 'indication', label: 'Hinweis auf' },
              { propertyName: 'dataCycle', label: 'Erhebungszyklus' },
              { propertyName: 'statement', label: 'Aussage' },
              { propertyName: 'source', label: 'Quelle' },
              {
                propertyName: 'levelOfAvailability',
                label: 'Ebene der Verfügbarkeit',
              },
              { propertyName: 'dataSupplier', label: 'Datenlieferant' },
            ];
            track $index
          ) {
            <div class="col-6">
              <p-fieldset [legend]="property.label">
                @if (selectedIndicator[property.propertyName]; as value) {
                  <span [innerHTML]="value"></span>
                } @else {
                  keine Angabe
                }
              </p-fieldset>
            </div>
          }
        </div>
      </p-accordionTab>

      @if (selectedIndicator.isSet) {
        <p-accordionTab header="Ausprägungen">
          @if (selectedChild && !selectedChild.isSet) {
            <p-dialog
              styleClass="z-top"
              [(visible)]="displayChildOverlay"
              appendTo="body"
              [styleClass]="'w-6'">
              <div class="overflow-y-scroll h-30rem">
                @if (
                  selectedChild._id !==
                  (indicator?._id || selectedIndicator?._id)
                ) {
                  <app-indicator-detail [indicator]="selectedChild" />
                }
              </div>
            </p-dialog>
          }

          <div class="p-datatable overflow-auto">
            <table class="p-datatable-table w-full">
              <thead class="p-datatable-thead">
                <tr>
                  <th><i class="fas fa-key"></i></th>
                  <th>Name</th>
                  <th></th>
                </tr>
              </thead>
              <tbody class="p-datatable-tbody">
                @for (
                  child of selectedIndicator.pool
                    ? store.filterPoolByParent(selectedIndicator._id)
                    : store.filterByParent(selectedIndicator._id);
                  track child._id
                ) {
                  <tr>
                    <td>
                      <code>{{ child.key }}</code>
                    </td>
                    <td>{{ child.name }}</td>
                    <td>
                      <div class="flex gap-3">
                        <p-button
                          [rounded]="true"
                          icon="fas fa-info"
                          severity="info"
                          styleClass="p-button-xs"
                          (click)="selectChild(child)"></p-button>
                        @if (!indicator) {
                          <p-button
                            [rounded]="true"
                            icon="fas fa-arrow-right"
                            severity="primary"
                            styleClass="p-button-xs"
                            (click)="
                              globalStore.setSelectedChildIndicator(child)
                            "></p-button>
                        }
                      </div>
                    </td>
                  </tr>
                }
              </tbody>
            </table>
          </div>
        </p-accordionTab>
      }
    </p-accordion>

    @if (
      displayIndicatorData &&
      !selectedIndicator.pool &&
      selectedIndicator &&
      dataStore.initialized()
    ) {
      <p-divider></p-divider>
      <app-header icon="fas fa-database" text="Daten" />
      <app-indicator-data-list
        [indicator]="
          selectedChild || selectedIndicator
        "></app-indicator-data-list>
    }
  </div>
  <p-sidebar
    (onHide)="onOverlayClose()"
    position="right"
    [modal]="false"
    [styleClass]="'w-8'"
    [visible]="editFormOverlay">
    <ng-template pTemplate="header">
      <app-header
        [icon]="editFormOverlayIcon"
        [text]="editFormOverlayHeader"></app-header
    ></ng-template>
    <ng-container *ngIf="editFormOverlay">
      <router-outlet name="bearbeiten"></router-outlet>
    </ng-container>
  </p-sidebar>
  <app-mask [visible]="editFormOverlay" (click)="onOverlayClose()"></app-mask>
} @else {
  <app-alert
    styleClass="m-0 px-3 pt-1 pb-3"
    header="Indikator auswählen"
    [canToggle]="false">
    Wählen Sie einen Indikator über die Suche oder das Indikatorenverzeichnis
    aus.
    <p-divider />
    <footer class="flex gap-3 flex-wrap">
      <p-button
        [rounded]="true"
        label="zum Indikatorenverzeichnis"
        icon="fas fa-folder-tree"
        [routerLink]="[{ outlets: { overlay: 'indikatoren' } }]"></p-button>
      @if (
        activeUserStore.canAccessPool() &&
        permissionService.hasAddRightsByEntityType('indicatorCategory')
      ) {
        <p-button
          [rounded]="true"
          label="zu den Indikatorenvorlagen"
          icon="fas fa-pen-ruler"
          [routerLink]="[{ outlets: { overlay: 'vorlagen' } }]"></p-button>
      }
    </footer>
  </app-alert>
}
